/* tslint:disable:member-ordering no-unused-variable */
import {ModuleWithProviders, NgModule, Optional, SkipSelf, OpaqueToken} from '@angular/core';
import {HttpModule} from "@angular/http";
import {RESTANGULAR, RestangularFactory} from './ng2-restangular.config';
import {Restangular} from './ng2-restangular';
import {RestangularHttp} from './ng2-restangular-http';

export const CONFIG_OBJ = new OpaqueToken('configObj');


export class RestangularModule {

  constructor(  parentModule: RestangularModule) {
    if (parentModule) {
      throw new Error(
        'RestangularModule is already loaded. Import it in the AppModule only');
    }
  }
  
  static forRoot(config1?, config2?): ModuleWithProviders {
    return {
      ngModule: RestangularModule,
      providers: [
        {provide: CONFIG_OBJ, useValue: [config1,config2]},
        {provide: RESTANGULAR, useFactory: RestangularFactory, deps: [CONFIG_OBJ]},
      ]
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [HttpModule],
  providers: [RestangularHttp, Restangular]
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: RestangularModule, decorators: [{ type: Optional }, { type: SkipSelf }, ]},
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
